import React from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
//import "materialize-css/dist/css/materialize.css";
import Package from "./Package";
import { connect } from "react-redux";
import Divider from "./Divider";
import { setActiveMenu } from "../actions";
import { Waypoint } from "react-waypoint";

class Carousel extends React.Component {
	items = [ 1, 2, 3, 4, 5 ];
	state = {
		currentIndex: 0,
		responsive: {
			1: { items: 1 },
			420: { items: 2 },
			600: { items: 2 },
			700: { items: 3 },
			800: { items: 3 },
			1024: { items: 3 },
			1280: { items: 4 }
		}
	};

	slideTo = (i) => this.setState({ currentIndex: i });

	onSlideChanged = (e) => {
		this.setState({ currentIndex: e.item });
	};

	slideNext = () => this.setState({ currentIndex: this.state.currentIndex + 1 });

	slidePrev = () => this.setState({ currentIndex: this.state.currentIndex - 1 });

	galleryItem(item, index) {
		return <Package index={index} store={this.props.store} />;
	}
	// const store = this.props.store.getState();
	items = this.items.map(this.galleryItem.bind(this));
	render() {
		const { responsive, currentIndex } = this.state;
		const { langBase } = this.props;
		return (
			<div>
				<Divider />
				<Waypoint bottomOffset={300} onEnter={() => this.props.setActiveMenu(3)} />
				<h1 id="price-table" className="main-subtitle">
					<button onClick={() => this.slidePrev()}>
						<i className="material-icons pointer">chevron_left</i>
					</button>{" "}
					<span className="first">{langBase.services.split(" ")[0]}</span> {langBase.services.split(" ")[1]}
					<button onClick={() => this.slideNext()}>
						<i className="material-icons pointer">chevron_right</i>
					</button>
				</h1>
				<p className="service_adv"> {langBase.services_adv} </p>

				<AliceCarousel
					items={this.items}
					dotsDisabled={false}
					swipeDisabled={false}
					buttonsDisabled={true}
					responsive={responsive}
					slideToIndex={currentIndex}
					onSlideChanged={this.onSlideChanged}
				/>
				<Waypoint bottomOffset={100} onEnter={() => this.props.setActiveMenu(3)} />
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	langBase: state.langBase
});

const mapDispatchToProps = {
	setActiveMenu
};

export default connect(mapStateToProps, mapDispatchToProps)(Carousel);
